import { typography, colors, mediaQueries } from '@everlywell/leaves';
import React from 'react';
import styled from 'styled-components';

import StyledA from '../styles/StyledA';

const Wrapper = styled.div`
  margin-top: 0;
  ${mediaQueries.forTabletHorizontalUp} {
    margin-top: 28%;
  }
  ${mediaQueries.forDesktopUp} {
    margin-top: 135px;
  }
`;

const TextBox = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0;
  ${mediaQueries.forDesktopUp} {
    margin: 0 auto;
  }
  a {
    color: ${colors.green4};
    text-decoration: none;
  }
`;

const DescriptionBlurb = styled.div`
  font-weight: ${typography.weight.light};
  font-size: 16px;
  line-height: 1.88;
  letter-spacing: 0.3px;
  border: 1px solid ${colors.gray4};
  padding: 12px 20px 13px 20px;
  margin: auto;
  width: 100%;
  color: ${colors.teal4};
  ${mediaQueries.forTabletVerticalUp} {
    width: 536px;
  }
  ${mediaQueries.forTabletHorizontalUp} {
    border: 0;
    padding: 0;
    width: 225px;
  }
  ${mediaQueries.forDesktopUp} {
    width: 335px;
  }
`;
const HorizontalRule = styled.hr`
  color: #d9d9d9;
  background-color: #d9d9d9;
  width: 218px;
  margin-top: 25px;
  margin-bottom: 23px;
  border: none;
  border-top: 1px;
  height: 1px;
  ${mediaQueries.forTabletVerticalDown} {
    display: none;
  }
  ${mediaQueries.forDesktopUp} {
    width: 335px;
  }
`;

const CompanyDescription = () => (
    <Wrapper>
      <TextBox>
        <DescriptionBlurb>
          Everlywell makes lab testing easy and convenient with at-home
          collection and digital results in days.{' '}
          <StyledA href="https://www.everlywell.com/">Learn More</StyledA>
        </DescriptionBlurb>

        <HorizontalRule />
      </TextBox>
    </Wrapper>
  );

export default CompanyDescription;
